const DIARY_DRAFT_KEY_PREFIX = 'diary-draft-'
const DIARY_DRAFT_MAX_AGE_MS = 2 * 24 * 60 * 60 * 1000

interface IDiaryDraft {
  text: string
  updatedAt: number
}

const getKey = (epicId: string) => `${DIARY_DRAFT_KEY_PREFIX}${epicId}`

const isValidDraft = (value: unknown): value is IDiaryDraft => {
  if (!value || typeof value !== 'object') return false
  const draft = value as IDiaryDraft
  return typeof draft.text === 'string' && typeof draft.updatedAt === 'number'
}

export const saveDiaryDraft_LS = (epicId: string, text: string) => {
  localStorage.setItem(
    getKey(epicId),
    JSON.stringify({ text, updatedAt: Date.now() }),
  )
}

export const getDiaryDraft_LS = (epicId: string): string | undefined => {
  const key = getKey(epicId)
  const rawDraft = localStorage.getItem(key)
  if (!rawDraft) return undefined

  try {
    const draft: unknown = JSON.parse(rawDraft)
    if (!isValidDraft(draft) || Date.now() - draft.updatedAt > DIARY_DRAFT_MAX_AGE_MS) {
      localStorage.removeItem(key)
      return undefined
    }
    return draft.text
  } catch {
    localStorage.removeItem(key)
    return undefined
  }
}

export const removeDiaryDraft_LS = (epicId: string) => {
  localStorage.removeItem(getKey(epicId))
}

export const removeExpiredDiaryDrafts_LS = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(DIARY_DRAFT_KEY_PREFIX))
    .forEach((key) => {
      const epicId = key.slice(DIARY_DRAFT_KEY_PREFIX.length)
      getDiaryDraft_LS(epicId)
    })
}
